/* eslint-disable */
import {Box, Card, Grid, Tooltip, Typography, withStyles} from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";
import {useStyles} from "../../style";
import Chart from "react-apexcharts";
import InfoIcon from "@material-ui/icons/Info";
import { height } from "@material-ui/system";

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const BarDonutER = ({ info }) => {

    console.log("retornoCapital", info["retornoCapital"])
    console.log("infoPAram", info)
    const theme = useTheme();
    const classes = useStyles([]);

    const dataDonuts = [
    {
      indicador: "Retorno de Capital",
      def: "El retorno de capital es una relación utilizada en finanzas, valoración y contabilidad, como una\n" +
          "medida de la rentabilidad y la potencial creación de valor de las empresas en relación con el monto de capital\n" +
          "invertido por los accionistas. Indica cuán efectiva es una empresa para convertir el capital en ganancias.",
      color: '#034886',
      colors: ['#034886','#034886'],
      bgColor: '#dbdcdc',
      series: [info["retornoCapital"]],
      type: "percentage",
    },
    {
      indicador: "Retorno de Activos (EBITDA)",
      color: '#034886',
      def: "El retorno de los activos (ROA) muestra el porcentaje de cuán\n" +
          "rentables son los activos de una empresa para generar ingresos. Este número le dice lo que la compañía puede hacer\n" +
          "con lo que tiene, es decir, cuántos dólares de ganancias obtienen de cada dólar de activos que controlan. Las\n" +
          "empresas que requieren grandes inversiones iniciales generalmente tendrán un menor rendimiento de los activos.\n" +
          "Los ROA de más del 5% generalmente se consideran buenos.",
      colors: ['#034886','#034886'],
      bgColor: '#dbdcdc',
      series: [info['ebitda']],
      type: "percentage",
    },
    {
      indicador: 'Retorno de Activos (ROA)',
      color: '#034886',
      def: "El retorno de los activos (ROA) muestra el porcentaje de cuán\n" +
          "rentables son los activos de una empresa para generar ingresos. Este número le dice lo que la compañía puede hacer\n" +
          "con lo que tiene, es decir, cuántos dólares de ganancias obtienen de cada dólar de activos que controlan. Las\n" +
          "empresas que requieren grandes inversiones iniciales generalmente tendrán un menor rendimiento de los activos.\n" +
          "Los ROA de más del 5% generalmente se consideran buenos.",
      colors: ['#034886','#034886'],
      bgColor: '#dbdcdc',
      series: [info['roa']],
      type: "percentage"
    },
    {
      indicador: 'Retorno de Inventario (GMROI)',
      color: '#034886',
      def: "El rendimiento del margen\n" +
          "bruto sobre la inversión en inventario es una relación que expresa el rendimiento de cada unidad monetaria gastada\n" +
          "en inventario. El GMROI responde a la pregunta &quot;por cada unidad de inventario promedio mantenida al costo,\n" +
          "¿cuántas unidades monetarias de ganancia bruta generé en un año?&quot;.",
      colors: ['#034886','#034886'],
      bgColor: '#dbdcdc',
      series: [info['retorno']],
      type: "number"
    }
  ]

  console.log("dataDonuts", dataDonuts)


    const buildStyles = (data) => {
        return {
            options: {
                chart: {
                    type: 'radialBar',
                    background: 'transparent',
                    stacked: false,
                    toolbar: {
                        show: false,
                    },
                    zoom: false,

                },
                plotOptions: {
                    radialBar: {
                        inverseOrder: false,
                        startAngle: 0,
                        endAngle: 360,
                        value: false,
                        track: {
                            background: data.bgColor,
                            strokeWidth: '130%',
                        },
                        dataLabels: {
                            showOn: 'always',
                            name: {
                                offsetY: 140,
                                show: true,
                                color: data.color,
                                fontSize: '15px',
                                fontWeight: 700,
                            },
                            value: {
                                formatter: function(val){
                                    if (data.type === "percentage"){
                                        return `${new Intl.NumberFormat('en-US', {
                                            style: "decimal",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }).format(val)}%`
                                    }else if (data.type === "number"){
                                        return `${new Intl.NumberFormat('en-US', {
                                            style: "decimal",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }).format(val)}`
                                    }
                                },
                                color: data.color,
                                fontSize: '22px',
                                show: true,
                                offsetY: -5,
                                fontWeight: 700,
                            },
                        },
                        hollow: {
                            size: '60%',
                        },
                    },
                },
                colors: data.colors,
                dataLabels: {
                    enabled: false,
                },
                labels: [''],
                stroke: {
                    width: 0,
                },
                theme: {
                    mode: theme.palette.mode,
                },
            },
            series: data.series,
        }
    }

    return(
            <Grid
                sx={{
                    p: 3,
                    height: '100%',
                    
                    
                }}
                
                container
                component={Card}
            >
                {dataDonuts.map(dataDonut => {
                    const chartStyles = buildStyles(dataDonut);
                    return (
                        <Grid
                            item
                            xs={6}
                            paddingBottom={3.75}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                               
                            }}
                        >
                            <Box  display="flex" justifyContent="center">
                                <Box>
                                    <Box pr={1} display="flex" justifyContent="end">
                                        <LightTooltip title={dataDonut.def}>
                                            <InfoIcon style={{color: "#FCBE00"}}/>
                                        </LightTooltip>
                                    </Box>
                                    <Box display="flex" alignItems="center" justifyContent="center" >
                                        <Typography className={classes.chartBarDonutText} textAlign={'center'}>
                                            {dataDonut.indicador}
                                        </Typography>
                                    </Box>
                                    <div className={classes.chartBarCost}>
                                        <Chart
                                            height="210px"
                                            width="100%"
                                            type="radialBar"
                                            {...chartStyles}
                                        />
                                    </div>
                                </Box>
                            </Box>
                        </Grid>
                    )
                })}
                <Box sx={{marginBottom: 1 , display: 'flex', justifyContent: 'center', width: "100%" }}>
                {/* <Typography  className={classes.disclaimerText}>
                    * Se muestran datos para el dia de mañana                          
                </Typography> */}
                </Box>
                
            </Grid>
    )
}

export default BarDonutER;
